export default "__VITE_ASSET__DHtpar91__"